// src/common/ui/card-utils.js
// Card interaction utilities

/** Focus guard to prevent selection changes */
export const focusGuard = { pause: false };

/**
 * Set pause state for selection
 * @param {boolean} on - Whether to pause
 */
export function setPauseSelection(on) {
  focusGuard.pause = !!on;
}

/**
 * Check if selection is paused
 * @returns {boolean}
 */
export function isPausedSelection() {
  return !!focusGuard.pause;
}

/**
 * Toggle card open/closed state
 * @param {HTMLElement} cardEl - Card element
 */
export function toggleCard(cardEl) {
  const header = cardEl.querySelector(".card-header");
  const body = cardEl.querySelector(".card-body");
  const isOpen = header.getAttribute("aria-expanded") === "true";
  header.setAttribute("aria-expanded", String(!isOpen));
  body.classList.toggle("show", !isOpen);
}

/**
 * Set card pending state with optional stage indicator
 * @param {HTMLElement} cardEl - Card element
 * @param {boolean} isPending - Whether card is pending
 * @param {string|null} stage - Optional stage label
 */
export function setCardPending(cardEl, isPending, stage = null) {
  const header = cardEl.querySelector(".card-header");
  if (!header) return;
  
  let pendingEl = header.querySelector(".pending");
  
  if (isPending) {
    if (!pendingEl) {
      pendingEl = document.createElement("span");
      pendingEl.className = "pending pending-stage";
      pendingEl.setAttribute("aria-live", "polite");
      pendingEl.textContent = "Pending…";
      header.append(pendingEl);
    }
    
    const stageText = stage ? `Stage: ${stage}` : "Pending…";
    pendingEl.textContent = stageText;
    
    if (stage) {
      const token = stage.toLowerCase().replace(/[^a-z0-9]+/g, "-");
      pendingEl.dataset.stage = token;
    } else {
      pendingEl.removeAttribute("data-stage");
    }
  } else {
    pendingEl?.remove();
  }
}

